import { Link, useLocation } from "react-router-dom";
import { formatTestId } from '../../util/EfupUtility'; 

const MenuItem = props => {
    const testId = formatTestId(`menu-item-${props.title}`)
    const location = useLocation();

    function isCurrentPage() {
        if (location.pathname === props.link) {
            return ' active-menu-item'
        }
        return '';
    }

    return (
        <li className={props.className + isCurrentPage()}>
            <Link to={{pathname: props.link}} data-testid={testId}>{props.title}</Link>
        </li>  
    )
}

export default MenuItem;